import { AvailableTimeslots } from './types/AvailableTimeslots';

export const ProviderTimeslotsService = {
  getAvailableTimeslots: async (date: Date): Promise<AvailableTimeslots> => {
    // mock implementation
    return {
      '01.03.2021': [
        { from: '13:00', to: '16:00', count: 6 },
        { from: '16:00', to: '18:00', count: 8 }
      ],
      '02.03.2021.': [
        { from: '13:00', to: '16:00', count: 6 },
        { from: '16:00', to: '18:00', count: 8 }
      ]
    };
  }
};
